import { CollapsibleCard } from "../CollapsibleCard";
import { SubmissionResponseDto } from "@/dto/get-project-response.dto";

interface SiteSafetySectionProps {
  submission: SubmissionResponseDto;
  defaultOpen?: boolean;
}

export const SiteSafetySection = ({
  submission,
  defaultOpen = false,
}: SiteSafetySectionProps) => {
  return (
    <CollapsibleCard
      title="2. Site & Safety Assessments"
      defaultOpen={defaultOpen}
    >
      <div className="space-y-4">
        <div className="grid grid-cols-1 gap-3 md:grid-cols-2 md:gap-4">
          <div className="flex justify-between md:flex-col md:justify-start md:space-y-1">
            <span className="text-sm font-medium text-muted-foreground">
              Fire Hazard Zone
            </span>
            <span className="text-sm font-medium">
              {submission.isFireHazardZone ? "Yes" : "No"}
            </span>
          </div>
          {submission.isFireHazardZone && submission.fireHazardDetails && (
            <div className="flex flex-col gap-1 md:space-y-1 md:mt-2">
              <span className="text-sm font-medium text-muted-foreground">
                Hazard Details
              </span>
              <span className="text-sm font-medium">
                {submission.fireHazardDetails}
              </span>
            </div>
          )}
          <div className="flex justify-between md:flex-col md:justify-start md:space-y-1">
            <span className="text-sm font-medium text-muted-foreground">
              Publicly Accessible
            </span>
            <span className="text-sm font-medium">
              {submission.isPubliclyAccessible ? "Yes" : "No"}
            </span>
          </div>
          <div className="flex justify-between md:flex-col md:justify-start md:space-y-1">
            <span className="text-sm font-medium text-muted-foreground">
              Propane Tank Storage
            </span>
            <span className="text-sm font-medium">
              {submission.hasLiquidPropaneTankStorage ? "Yes" : "No"}
            </span>
          </div>
        </div>
      </div>
    </CollapsibleCard>
  );
};
